/* eslint-disable */
import React, { Component } from "react";
import AgentDetailContainer from "../containers/AgentDetailContainer/AgentDetailContainer";
import PropTypes from "prop-types";
import NextHead from "next/head";
import {
  farProfile,
  feedback,
  profile,
  recommendation,
  clickDetectorAndScroll,
  hestiaInformation,
} from "../store/actions/profile.action";
import { SEO_SCHEMA, SELECT_TYPE } from "../util/constant";
import { getProfileUrl } from "../util/createProfileIdPath";
import { formatFeedbackData } from "../util/formatFeedbackData";
import { createHrefLang } from "../util/createHrefLang";
import ErrorPage from "./_error";
import { getPixelScript } from "util/stringUtil";
import { isPrivacyOptOutFromCtx } from "util/privacy";
import { getSeoMetaLDP } from "../util/ldpUtil/seoMetaLdp";
import { getHeastiaCallBodyData } from "util/agentdetailsUtil";
const { checkBotAndType } = require("../api/utils/botAndTypeDetector");

export default class agentdetail extends Component {
  static async getInitialProps(ctx) {
    const referrer = ctx.req?.get('Referer');
    let isOrganicSearch = false;
    const { advertiser_id, selectedType, nrds_id, langCode, profileId } = ctx && ctx.query;
    const store = ctx && ctx.reduxStore;
    const res = ctx && ctx.res;
    const { req } = ctx;
    let hostUrl;
    if (req) {
      hostUrl = `https://${req.headers.host}`; // will give you localhost:3000

      // console.log("hostUrl", hostUrl);
    }

    let advertiserId, seoData, content, jsonld, feedbackData;
    //getting seoUserType from request
    const request = ctx && ctx.req;
    const { isBot, isGoogleBot, deviceType, deviceSubType } = checkBotAndType(request);
    let seoUserType = {
      isBot,
      deviceType,
      deviceSubType,
    };
    seoUserType = seoUserType && JSON.stringify(seoUserType);
    if (referrer?.includes("google.com") || referrer?.includes("bing.com")) {
      isOrganicSearch = true;
    }
    const isLexAgentListRequired = false;
    //Fetching Hestia Data
    if (advertiser_id || nrds_id || profileId) {
      await farProfile(
        advertiser_id,
        selectedType,
        nrds_id,
        langCode,
        seoUserType,
        profileId,
        isLexAgentListRequired,
        isGoogleBot
      )(store.dispatch);
    }

    const storeData = store.getState();
    let agentDetails = storeData?.profile?.agentdetail?.agent_bio;
    //Calling Profile API
    const advertiser_id_profile = storeData?.profile?.agentdetail?.agent_bio?.advertiser_id;
    const nrds_id_profile = storeData?.profile?.agentdetail?.agent_bio?.nrds_id;

    if (advertiser_id_profile && nrds_id_profile) {
      await profile(advertiser_id_profile, nrds_id_profile)(store.dispatch);
    }
    let agentDetail = storeData?.profile?.agentdetail;

    //Calling Hestia API
    if (isGoogleBot) {
      if (agentDetail) {
        const { advertiserIdHestia, agents, type } = getHeastiaCallBodyData(agentDetail) || {};
        if (advertiserIdHestia && advertiserIdHestia.length > 0) {
            await hestiaInformation(advertiserIdHestia, agents, 1, type, "agentdetail")(store.dispatch);
        }
      }
    }

    if (!agentDetails) {
      if (isGoogleBot || isBot)
        res.status(410);
      else
        res.status(404);
    }
    if (!nrds_id) {
      advertiserId = advertiser_id;
    } else if (agentDetails) {
      const { advertiser_id } = agentDetails;
      advertiserId = advertiser_id;
    }

    if (advertiser_id_profile) {
      //Fetching Review  Data
      await feedback(advertiser_id_profile)(store.dispatch);

      //Fetching Recommandation  Data
      await recommendation(advertiser_id_profile)(store.dispatch);
    }
    store.dispatch(clickDetectorAndScroll(null));

    feedbackData = store.getState()?.profile?.feedbackData;

    // Prepare jsonld data for seo schema
    const {
      first_name,
      last_name,
      full_name,
      name,
      person_name,
      description,
      phones,
      photo,
      office,
      user_languages,
      address,
      agent_rating,
      settings,
      review_count,
      id,
    } = agentDetails || {};
    const disp_rat = settings && settings.display_ratings;
    const telephone = phones && phones.find((phone) => phone.type === "Office" || "Mobile");
    const schemaTypes = ["AgentInfo", "Review"];
    const defaultAgentImage = "https://www.realtor.com/realtor-com.png";
    content = {
      agentName: full_name || person_name || name,
      firstName: first_name,
      lastName: last_name,
      silos: SEO_SCHEMA.LDP_SILO[selectedType],
      description: description,
      url: getProfileUrl(id, SELECT_TYPE.AGENT),
      telephone: telephone?.number,
      image: photo?.href || defaultAgentImage,
      officeName: office?.name,
      knowsLanguage: user_languages,
      location: {
        ...address,
      },
      averagegRating: {
        ratingValue: disp_rat == true ? agent_rating : null,
        reviewCount: disp_rat == true ? review_count : null,
      },
      agentReviews: disp_rat == true ? formatFeedbackData(feedbackData) : null,
      inLanguage: ctx.query.langCode,
      localUrl: `${ctx.asPath}` || null,
      isBotAndDeviceType: seoUserType && JSON.parse(seoUserType),
    };
    if (content && content.url) jsonld = { schemaTypes, content };
    return { query: ctx.query, jsonld, agentDetails, hostUrl, isGoogleBot, isOrganicSearch, privacyOptOut: isPrivacyOptOutFromCtx(req), pageName: 'FAR:Agent Detail Page' };
  }

  componentDidMount() {
    localStorage.setItem("listingPage", 1);
  }

  render() {
    const { query, jsonld, agentDetails, hostUrl, isGoogleBot, isOrganicSearch, privacyOptOut } =
      this.props || {};
    const metaData = getSeoMetaLDP(query, SELECT_TYPE.AGENT, agentDetails);
    //Get metadata and snippets from seoData.
    const { langCode } = query || {};
    let webUrl = null;
    if (agentDetails) webUrl = getProfileUrl(agentDetails.id, SELECT_TYPE.AGENT);
    const defaultTitle =
      langCode === "es"
        ? "Agente de Bienes Raíces en su Área - realtor.com®"
        : "Real Estate Agent in Your Area | realtor.com®";
    const defaultDescription =
      langCode === "es"
        ? "Encuentre agente de bienes raíces y Realtor® su ciudad en Realtor.com®, su fuente para encontrar los profesionales en bienes raíces mejor calificados"
        : "Find real estate agents in Your City on realtor.com®, your source for top rated real estate professionals.";
    const defaultCanonicalUrl =
      langCode === "es"
      ? "https://www.realtor.com/realestateagents/"
      : "https://www.realtor.com/realestateagents/es/";
    const { title, description, canonical_url } = metaData || {};

    const { use_dot_realtor_for_search_engines, has_dotrealtor } = agentDetails?.settings || {};

    const { content } = jsonld || {};
    const { image, isBotAndDeviceType } = content || {};
    const { engUrl, esUrl } = createHrefLang(content, agentDetails);
    // const nrds_id = agentDetails && agentDetails.nrds_id;
    const dotRealtorCanonicalUrl =
      use_dot_realtor_for_search_engines && has_dotrealtor ? hostUrl : canonical_url;
    if (!agentDetails) {
      return <ErrorPage status_code={404} />;
    }
    const pixelScript = privacyOptOut ? null : getPixelScript("FAR Detail Page");
    return (
      <>
          <NextHead>
            <title>{title || defaultTitle}</title>
            <meta name="description" content={description || defaultDescription}></meta>
            <link rel="canonical" href={dotRealtorCanonicalUrl || defaultCanonicalUrl}></link>
            <link rel="alternate" hrefLang="es-us" href={esUrl} />
            <link rel="alternate" hrefLang="en-us" href={engUrl} />
            <link rel="alternate" hrefLang="x-default" href={engUrl} />
            <meta key="og:url" content={canonical_url || webUrl || defaultCanonicalUrl} />
            <meta property="og:title" content={title || defaultTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonical_url || webUrl || defaultCanonicalUrl} />
            <meta property="og:site_name" content="Realtor.com" />
            <meta property="og:image" content={image}></meta>
            <meta key="twitter:title" property="twitter:title" content={title || defaultTitle} />
            <meta
              key="twitter:description"
              property="twitter:description"
              content={description || defaultDescription}
            />
            <meta
              key="twitter:site"
              name="twitter:site"
              property="twitter:site"
              content="@realtordotcom"
            />
            <meta name="twitter:card" content="Summary" />
            <meta name="apple-mobile-web-app-title" content={title || defaultTitle} />
            <meta name="apple-mobile-web-app-status-bar-style" content="default" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="mobile-web-app-capable" content="yes" />
            {pixelScript ? (
              <script
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                  __html: `${pixelScript}`,
                }}></script>
            ) : null}
          </NextHead>
          <AgentDetailContainer
            isBotAndDeviceType={isBotAndDeviceType}
            isGoogleBot={isGoogleBot}
            query={query}></AgentDetailContainer>
      </>
    );
  }
}

agentdetail.propTypes = {
  agentdetail: PropTypes.object,
  feedbackData: PropTypes.array,
  recommendationData: PropTypes.array,
  hestiaFinalResult: PropTypes.object,
  query: PropTypes.object,
  parserData: PropTypes.object,
  seoData: PropTypes.object,
  agentDetails: PropTypes.object,
  jsonld: PropTypes.object,
  isOrganicSearch: PropTypes.bool,
};
